import { render, staticRenderFns } from "./OnTheWay.vue?vue&type=template&id=14b957f3&scoped=true"
import script from "./OnTheWay.vue?vue&type=script&lang=js"
export * from "./OnTheWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b957f3",
  null
  
)

export default component.exports